import CircleBreadcrumbButton from '@/circle/components/CircleBreadcrumbButton'
import PanelLayout from '@/common/atoms/PanelLayout'
import { Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import useVacantRoles from '../hooks/useVacantRoles'

interface Props {
  changeTitle?: boolean
  flowHeight?: boolean
  onClose?: () => void
}

// Roles nobody fills, as a panel of the org chart page.
export default function VacantRolesContent(panelProps: Props) {
  const { t } = useTranslation()
  const vacantCircles = useVacantRoles()

  return (
    <PanelLayout title={t('VacantRolesPanel.heading')} {...panelProps}>
      {vacantCircles.length === 0 ? (
        <Text fontStyle="italic">{t('VacantRolesPanel.empty')}</Text>
      ) : (
        <VStack align="stretch" spacing={0}>
          {vacantCircles.map((circle) => (
            <CircleBreadcrumbButton key={circle.id} circle={circle} />
          ))}
        </VStack>
      )}
    </PanelLayout>
  )
}
